<script setup lang="ts">
import { onMounted, computed, ref, onUnmounted } from 'vue'
import { APP_LOGO, IS_BAYER_APP, IS_SAIFTY } from '@/config/customers'

const SHOW_BLANK_PAGE_ON_HOME_REDIRECTION = window.ENV.SHOW_BLANK_PAGE_ON_HOME_REDIRECTION
const size = ref<string>('1rem')

onMounted(() => {
  size.value = '4rem'

  if (IS_BAYER_APP) {
    //when the Loading component is mounted we change the StateBarColor to white - because it has a color by default
    changeStateBarColor('#ffffff')
  }
})

onUnmounted(() => {
  if (IS_BAYER_APP) {
    // when the Loading component is unmounted we change the StateBarColor back to the default secondary page color
    changeStateBarColor('#10384f')
  }
})

const iconStyle = computed(() => ({
  height: size.value,
  transition: 'height 1.5s',
}))

function changeStateBarColor(color: string) {
  const themeColorMetaTag = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement
  if (themeColorMetaTag) {
    themeColorMetaTag.setAttribute('content', color)
  }
}
</script>

<template>
  <div
    v-if="SHOW_BLANK_PAGE_ON_HOME_REDIRECTION"
    class="text-center w-100 h-100 d-grid justify-content-center align-content-center"
  ></div>
  <div
    v-else
    class="text-center w-100 h-100 d-grid justify-content-center align-content-center align-items-center"
    :class="[{ 'bg-primary': IS_SAIFTY }, { 'd-flex my-auto': IS_BAYER_APP }]"
  >
    <img :src="APP_LOGO" :class="IS_SAIFTY ? 'white-logo' : ''" :style="iconStyle" alt="Loading..." />
    <template v-if="IS_BAYER_APP">
      <div class="border-primary border-2 border-start me-3 ms-2" :style="iconStyle"></div>
      <img src="/bayer-logo.png" alt="Bayer" :style="iconStyle" />
    </template>
  </div>
</template>

<style scoped></style>
